import { useMemo } from 'react';
import Image from '@alltrails/core/components/Image';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import { useAppSelector } from '@/utils/redux';
import groundConditionsSrc from './staticImages/groundConditions.avif';
import precipitationImperialSrc from './staticImages/imperial/precipitation.avif';
import snowDepthImperialSrc from './staticImages/imperial/snowDepth.avif';
import temperatureImperialSrc from './staticImages/imperial/temperature.avif';
import precipitationMetricSrc from './staticImages/metric/precipitation.avif';
import snowDepthMetricSrc from './staticImages/metric/snowDepth.avif';
import temperatureMetricSrc from './staticImages/metric/temperature.avif';
import styles from './TrailConditionsUpsellCard.module.scss';

type StaticImageProps = {
  condition: ConditionStyleId;
};

const StaticImage = ({ condition }: StaticImageProps) => {
  const displayMetric = useAppSelector(state => state.context.displayMetric);

  const src = useMemo(() => {
    if (condition === 'groundConditions') {
      return groundConditionsSrc;
    }
    if (displayMetric) {
      switch (condition) {
        case 'precipitation':
          return precipitationMetricSrc;
        case 'snowDepth':
          return snowDepthMetricSrc;
        case 'temperature':
          return temperatureMetricSrc;
      }
    }
    switch (condition) {
      case 'precipitation':
        return precipitationImperialSrc;
      case 'snowDepth':
        return snowDepthImperialSrc;
      case 'temperature':
        return temperatureImperialSrc;
    }
    return null;
  }, [condition, displayMetric]);

  return <Image alt="" className={styles.staticImage} src={src} />;
};

export default StaticImage;
